export const getters = {
  systemBondtrackings: state => state.bondtrackings,
  Bondtracking: state => state.systemBondtracking
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/bondtrackings/getters.js